import api from '../../services/api';

export const viewRegulation = async (id: string) => {
  const response = await api.post(`/regulations/${id}/view`);

  if (!response) {
    throw new Error('Failed to set regulation view');
  }

  return response.data;
};

export const renewalRegulation = async (id: number, onSuccess?: () => void) => {
  const response = await api.post(`/regulations/${id}/renewal/?id=${id}`);

  if (!response) {
    throw new Error('Failed to set regulation view');
  }
  
  if (onSuccess) {
    onSuccess();
  }

  return response.data;
};

export const fetchDraftRegulationById = async (
  id: number | string | undefined | null,
  history?: boolean,
) => {
  const response = await api.get(`/regulations/${id}${history ? '?history=true' : ''}`);
  if (!response) {
    throw new Error('Failed to fetch Organization Unit List');
  }
  return response.data;
};

export const createDraftRegulation = async (data: FormData) => {
  const response = await api.post(`/regulationDrafts`, data);
  if (!response) throw new Error('Failed to create draft regulation');
  return response.data;
};

export const updateDraftRegulation = async (data: FormData) => {
  const response = await api.put(`/regulationDrafts`, data);
  if (!response) throw new Error('Failed to create draft regulation');
  return response.data;
};

export const rejectDeleteRegulation = async ({ id }: { id: string | undefined }) => {
  const response = await api.post(`/regulations/${id}/rejectDeleteRequest`);
  if (!response) throw new Error('Failed to request publish regulation');
  return true;
};

export const approveDeleteRegulation = async ({
  id,
  data,
}: {
  id: string | undefined;
  data: { title: string | null; requestMessage: string | null; distributionLists: number[] | null };
}) => {
  const response = await api.post(`/regulations/${id}/approveDeleteRequest`, data);
  if (!response) throw new Error('Failed to approve delete regulation');
  return id;
};

export const requestDeleteRegulation = async ({
  id,
  data,
}: {
  id: string | undefined;
  data: { deletionMessage: string };
}) => {
  const response = await api.post(`/regulations/${id}/requestDelete?id=${id}`, data);
  if (!response) throw new Error('Failed to request publish regulation');
  return true;
};